import { displayFontFamily } from "styles/theme";

const CREAM = "#f9f8f7";
const PURPLE = "#b1b3f8";

const influencerImage =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/signup_photo.jpeg";

const heroGradient =
  "radial-gradient(68% 58% at 88% 2%, rgba(247,238,111,.18), transparent 60%), radial-gradient(125% 130% at 48% -5%, #0d5947 0%, #044133 48%, #01251d 100%)";

const heroWithPhoto = `linear-gradient(160deg, rgba(4,65,51,0.92) 0%, rgba(1,37,29,0.82) 55%, rgba(1,37,29,0.95) 100%), radial-gradient(68% 58% at 88% 2%, rgba(247,238,111,.16), transparent 60%), url(${influencerImage})`;

const styles = {
  page: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
  },

  brandPanel: {
    position: "relative",
    overflow: "hidden",
    flexBasis: "48%",
    flexShrink: 0,
    minHeight: "100vh",
    background: heroWithPhoto,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    p: 6,
  },
  orbYellow: {
    position: "absolute",
    width: 540,
    height: 540,
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(247,238,111,.18), transparent 64%)",
    top: -180,
    right: -140,
    pointerEvents: "none",
  },
  orbPurple: {
    position: "absolute",
    width: 560,
    height: 560,
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(177,179,248,.20), transparent 64%)",
    bottom: -240,
    left: -160,
    pointerEvents: "none",
  },
  brandContent: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    flex: 1,
    maxWidth: 560,
  },
  logo: {
    height: 30,
    width: "auto",
    cursor: "pointer",
    alignSelf: "flex-start",
  },
  brandMain: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    py: 5,
  },
  header: {
    fontFamily: displayFontFamily,
    fontWeight: 900,
    letterSpacing: "-0.03em",
    color: CREAM,
    fontSize: { md: 40, lg: 46 },
    lineHeight: 1.18,
    mb: 4,
  },
  highlight: {
    color: "#151f16",
    backgroundImage: `linear-gradient(${PURPLE}, ${PURPLE})`,
    backgroundSize: "100% 62%",
    backgroundPosition: "0 72%",
    backgroundRepeat: "no-repeat",
    px: "0.1em",
    boxDecorationBreak: "clone",
    WebkitBoxDecorationBreak: "clone",
  },
  brandLink: {
    color: "yellow.main",
    textDecoration: "none",
    cursor: "pointer",
  },
  brandLinkPlain: {
    color: "inherit",
    textDecoration: "none",
    cursor: "pointer",
  },
  cardRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1.5,
  },
  card: {
    flex: "1 1 150px",
    color: CREAM,
    position: "relative",
    p: 2,
    borderRadius: 4,
    fontSize: 13,
    lineHeight: 1.4,
    background: "rgba(249,248,247,0.07)",
    border: "1px solid rgba(249,248,247,0.14)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
  },
  cardStat: {
    fontFamily: displayFontFamily,
    fontWeight: 900,
    fontSize: 20,
    letterSpacing: "-0.02em",
    mb: 0.5,
  },
  littleCircle: {
    position: "absolute",
    top: 12,
    right: 12,
    width: 10,
    height: 10,
    borderRadius: "50%",
  },
  glass: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    gap: 2,
    alignItems: "center",
    p: 2.5,
    borderRadius: 4,
    background: "rgba(249,248,247,0.07)",
    border: "1px solid rgba(249,248,247,0.14)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
  },
  testimonialAvatar: {
    height: 72,
    width: 72,
    borderRadius: 2,
    objectFit: "cover",
    flexShrink: 0,
  },
  testimonialQuote: {
    color: "rgba(249,248,247,.9)",
    fontSize: 12.5,
    lineHeight: 1.55,
  },
  testimonialEarnings: {
    fontSize: 13,
    color: PURPLE,
    fontWeight: 600,
  },
  testimonialName: {
    color: CREAM,
    fontSize: 12,
    mt: 0.75,
  },

  formPanel: {
    flex: 1,
    minWidth: 0,
    background: CREAM,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    p: { xs: 3, md: 6 },
  },
  formCard: {
    width: "100%",
    maxWidth: 440,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  text: {
    color: "rgba(21,31,22,.62)",
    fontSize: 14,
    textAlign: "center",
    mt: 5,
  },
  promoOff: {
    color: "#014638",
    fontWeight: 700,
  },

  mobilePage: {
    background: heroGradient,
    position: "fixed",
    overflowY: "auto",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    px: 2,
    py: 4,
  },
  mobileContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: 440,
    my: "auto",
  },
  mobileHeader: {
    fontFamily: displayFontFamily,
    fontWeight: 900,
    letterSpacing: "-0.02em",
    color: CREAM,
    fontSize: 24,
    lineHeight: 1.1,
    mb: 2,
  },
  mobileCard: {
    px: 2,
    py: 0.75,
    background: "rgba(249,248,247,0.08)",
    border: "1px solid rgba(249,248,247,0.18)",
    color: CREAM,
    borderRadius: 999,
    fontSize: 12,
  },
  mobilePromo: {
    color: "rgba(249,248,247,.8)",
    mt: 3,
    fontSize: 12,
  },
  mobilePromoOff: {
    fontSize: 14,
    color: PURPLE,
  },
};

export default styles;
